import mixins from '@/mixins';

export default {
  name: 'TermsOfService',

  mixins: [mixins],

  data() {
    return {
      currentYear: new Date().getFullYear(),
      // 格式化为 26 July 2026 风格
      formattedDate: new Date().toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
      })
    }
  },
}
